import {useTranslation} from "react-i18next";
import {useEffect} from "react";
import reportTemplateColumns from "./ReportTemplateColumns";
import DataGrid from "../../../core/components/data-grid/DataGrid";
import ApiService from "../../../core/service/api-service";
import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import {Button, Space} from "antd";
import ReportTemplateCreateEditForm from "../ReportTemplateCreateEditForm";
import {useModal} from "../../../core/context/ModalContext";

export default function ReportTemplateGrid({})
{
    const {t} = useTranslation();
    const {setDataGridProps, queryModel, setData, setPaginationResult} = useDataGrid();
    const {openModal} = useModal()

    const initGridData = async () => {
        const response = await ApiService.ReportTemplate.GetDataGrid(queryModel)
        setPaginationResult(response.pagination);
        setData(response.data)
    }

    useEffect(() => {
        initGridData()
    }, [queryModel.updateKey])

    useEffect(() => {
        setDataGridProps({
            rowKey: 'id',
            columns: reportTemplateColumns(t)
        })
    }, [])

    return (
        <>
            <DataGrid
                title={() => (
                    <Space>
                        <Button
                            size={'small'}
                            onClick={() => {
                                openModal(
                                    t('New Report Template'),
                                    <ReportTemplateCreateEditForm />,
                                    () => {}
                                )
                            }}
                        >
                            {t('New Report Template')}
                        </Button>
                    </Space>
                )}
                name={'report-template'}
            />
        </>
    )
}
